<div class="p-3">

  <div class="d-flex align-items-center justify-content-between mb-3">
    <div>
      <h2 class="mb-1">API Tokens</h2>
      <p class="text-muted mb-1">
        Create long-lived tokens to connect third-party systems to the API on your behalf.
        Tokens use your current permissions across all your accounts, resolved on every request.
      </p>
      <p class="text-muted small mb-0">
        <mat-icon class="align-middle mr-1 disclaimer-icon">info</mat-icon>
        Public API documentation is not yet available. These tokens are intended for existing
        integrations and in preparation for documentation we will publish in the future.
      </p>
    </div>
    <button mat-raised-button color="primary" (click)="onGenerate()">
      <mat-icon>add</mat-icon>
      Generate New Token
    </button>
  </div>

  <div class="alert alert-info" *ngIf="loaded && tokens.length === 0">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You have not created any API tokens yet. Use "Generate New Token" to create one.
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="tokens.length > 0">
    <table mat-table [dataSource]="tokens" class="w-100">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let token">{{ token.name }}</td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let token">{{ token.created_at | date: 'medium' }}</td>
      </ng-container>

      <ng-container matColumnDef="last_used_at">
        <th mat-header-cell *matHeaderCellDef>Last Used</th>
        <td mat-cell *matCellDef="let token">
          <span *ngIf="token.last_used_at">{{ token.last_used_at | date: 'medium' }}</span>
          <span class="text-muted" *ngIf="!token.last_used_at">Never used</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="expires_at">
        <th mat-header-cell *matHeaderCellDef>Expires</th>
        <td mat-cell *matCellDef="let token">
          <span class="text-muted" *ngIf="token.never_expires">Never expires</span>
          <span *ngIf="!token.never_expires">{{ token.expires_at | date: 'medium' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-right">Actions</th>
        <td mat-cell *matCellDef="let token" class="text-right">
          <button mat-icon-button color="warn" (click)="onRevoke(token)" matTooltip="Revoke token">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

</div>
